import script from "./MockupButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MockupButton.vue?vue&type=script&setup=true&lang=js"

import "./MockupButton.vue?vue&type=style&index=0&id=5d35a842&lang=scss"

const __exports__ = script;

export default __exports__